import React from 'react';

const Pricing = () => {
  return (
    <div className="container-fluid text-dark p-5" style={{ backgroundColor: '#E6EBF0' }}>
      <h2 className="text-center mb-4">Our Pricing</h2>
      <div className="row">
        <div className="col-md-4">
          <div className="card mb-4 text-dark">
            <div className="card-body">
              <h5 className="card-title">Individual Session</h5>
              <p className="card-text">One-on-one sessions with our expert consultants. Includes session, essay review, and our tools and research to bring your application to the next level!</p>
              <p className="fw-bold"><s>$100</s>$70/hour (30% off!)</p>
            </div>
          </div>
        </div>
        <div className="col-md-4">
          <div className="card mb-4 text-dark">
            <div className="card-body">
              <h5 className="card-title">Duo Sessions</h5>
              <p className="card-text">Bring your friend or sibling to reach your goals together! Two-client sessions with our expert consultants. Includes session, essay review, and our tools and research to bring your application to the next level! Pricing is per person.</p>
              <p className="fw-bold"><s>$70</s>$49/hour (30% off!)</p>
            </div>
          </div>
        </div>
        <div className="col-md-4">
          <div className="card mb-4 text-dark">
            <div className="card-body">
              <h5 className="card-title">Group Sessions</h5>
              <p className="card-text">Sessions for larger groups of three or more. Includes session, more limited essay review, and our tools and research to bring your application to the next level! Pricing is per person.</p>
              <p className="fw-bold"><s>$60</s>$42/hour (30% off!)</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Pricing;
